module.exports = __webpack_public_path__ + "img/loading.dbdeae45.gif";